<div class="custom-field-collection" *ngFor="let collectionAndInstance of customFieldCollectionsAndValues(); let i = index">
  <button type="button"
          class="collection-header"
          (click)="toggleCollection(collectionAndInstance.collection.id)">
    <span class="chevron" [class.expanded]="isCollectionExpanded(collectionAndInstance.collection.id)">▸</span>
    <span class="title">{{ collectionAndInstance.collection.title }}</span>
    <nb-icon *ngIf="collectionAndInstance.instance?.collection?.deleted"
             icon="alert-triangle-outline" pack="eva" status="warning"
             nbTooltip="Diese Feldgruppe wurde gelöscht" nbTooltipStatus="warning"></nb-icon>
  </button>

  <div class="collection-body" *ngIf="isCollectionExpanded(collectionAndInstance.collection.id)">
    <wr-custom-form [collection]="collectionAndInstance.collection"
                    [instance]="collectionAndInstance.instance"
                    [readonly]="formReadonly()">
    </wr-custom-form>
  </div>
</div>
